export default {
  data() {
    return {
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '判决时间',
          width: 120,
          dataIndex: 'judgmentDate',
          key: 'judgmentDate',
        },
        {
          title: '案号',
          dataIndex: 'caseNumber',
          key: 'caseNumber',
          width: 200,
        },
        {
          title: '标题',
          width: 550,
          dataIndex: 'title',
          key: 'title',
          ellipsis: true,
          scopedSlots: { customRender: 'titleRender' },
        },
        {
          title: '当事人身份',
          dataIndex: 'relatedPosition',
          key: 'relatedPosition',
        },
        {
          title: '案由',
          dataIndex: 'causeAction',
          key: 'causeAction',
          width: 350,
        },
        {
          title: '文书类型',
          dataIndex: 'documentType',
          key: 'documentType',
        },
        {
          title: '诉讼类型',
          dataIndex: 'litigationType',
          key: 'litigationType',
        },
        {
          title: '审判流程',
          dataIndex: 'trialClass',
          key: 'trialClass',
        },
        {
          title: '判决结果',
          dataIndex: 'resultOfVictoryOrDefeat',
          key: 'resultOfVictoryOrDefeat',
        },
        {
          title: '判决金额',
          dataIndex: 'amountOfJudicialDecision',
          key: 'amountOfJudicialDecision',
        },
      ],
    }
  },
}
